import { gql } from 'graphql-request'

export const exportRequest = gql`
  mutation InitiateExportRequest(
    $exportName: ExportNames!
    $exportRequest: ExportRequestArgument!
  ) {
    initiateExportRequest(exportName: $exportName, exportRequest: $exportRequest) {
      id
      status
    }
  }
`

export const activeExportRequest = gql`
  mutation ActiveExportRequest($requestId: String!) {
    activeExportRequest(requestId: $requestId) {
      id
      userId
      status
      createdAt
      updatedAt
      url
      export
    }
  }
`

export const clearExportRequestHistory = gql`
  mutation ClearExportRequestHistory {
    clearExportRequestHistory {
      id
    }
  }
`

export const deleteExportRequest = gql`
  mutation DeleteExportRequest($requestId: String!) {
    deleteExportRequest(requestId: $requestId) {
      id
    }
  }
`
